// extracted by mini-css-extract-plugin
export default {"form":"stack-page_form__HfO1O","wrapper":"stack-page_wrapper__FY1XA","series":"stack-page_series__eWLjw"};